import { Component, OnInit, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { ResourceSkill } from "@app/models/rest/resource-skill";
import { ResourceModel } from "@app/models/rest/resource";
import { Skill } from "@app/models/rest/skill";
import { ResourceFactMappingPattern } from "@app/models/rest/resource-fact-mapping-pattern";
import { CdkScrollable } from "@angular/cdk/scrolling";
import {
  MatFormField,
  MatLabel,
  MatError,
  MatSuffix
} from "@angular/material/form-field";
import { MatSelect } from "@angular/material/select";
import { MatOption } from "@angular/material/core";
import { MatInput } from "@angular/material/input";
import {
  MatDatepickerInput,
  MatDatepickerToggle,
  MatDatepicker
} from "@angular/material/datepicker";
import { MatButton } from "@angular/material/button";
import { DialogHeaderComponent } from "@app/view/shared/dialog-header/dialog-header.component";
import moment from "moment";

interface SkillSelectionDialogData {
  resource: ResourceModel;
  skills: Skill[];
  mappingPatterns: ResourceFactMappingPattern[];
}

@Component({
  selector: "app-skill-selection-dialog",
  templateUrl: "./skill-selection-dialog.component.html",
  styleUrls: ["./skill-selection-dialog.component.scss"],
  imports: [
    DialogHeaderComponent,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatError,
    MatInput,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    MatDialogActions,
    MatButton
  ]
})
export class SkillSelectionDialogComponent implements OnInit {
  private fb = inject(FormBuilder);
  private dialogRef =
    inject<MatDialogRef<SkillSelectionDialogComponent>>(MatDialogRef);
  data = inject<SkillSelectionDialogData>(MAT_DIALOG_DATA);

  skillForm: FormGroup;

  ngOnInit(): void {
    // Set up the form
    this.skillForm = this.fb.group({
      skill: [null, Validators.required],
      startDate: [null],
      endDate: [null],
      mappingPattern: [null]
    });
  }

  saveSkill(): void {
    if (!this.skillForm.valid) {
      return;
    }

    const formValues = this.skillForm.value;
    const entry: Partial<ResourceSkill> = {
      resource: this.data.resource,
      skill: formValues.skill,
      startDate: formValues.startDate
        ? moment(formValues.startDate).startOf("day").toDate()
        : null,
      endDate: formValues.endDate
        ? moment(formValues.endDate).startOf("day").toDate()
        : null,
      mappingPattern: formValues.mappingPattern
    };

    this.dialogRef.close({ action: "save", entry });
  }

  cancel(): void {
    this.dialogRef.close({ action: "cancel" });
  }
}
